/**
 * Layout principal: Sidebar + Header + ContentArea.
 */
import { type ReactNode } from 'react';
import { Sidebar } from '@/components/shared/layout/Sidebar/Sidebar';
import { Header } from '@/components/shared/layout/Header/Header';
import type { Crumb } from '@/components/shared/navigation/Breadcrumb';

type MainLayoutProps = {
  children: ReactNode;
  crumbs?: Crumb[];
  rightSlot?: ReactNode;
};

export function MainLayout({ children, crumbs, rightSlot }: MainLayoutProps) {
  return (
    <div className="flex min-h-screen bg-[#f5f6fa]">
      <Sidebar />
      <div className="flex flex-1 flex-col lg:pl-[260px]">
        <Header crumbs={crumbs} rightSlot={rightSlot} />
        <main role="main" className="flex-1">
          {children}
        </main>
      </div>
    </div>
  );
}
